function Profile() {
  return (
    <div className='flex flex-1 justify-center items-center'>
      <p className='text-2xl font-bold'>Profile</p>
    </div>
  );
}

export default Profile;
